export const baseURL = "https://cosmos.bajajfinservsecurities.in/api/rm";
export const esopBaseURL = "https://cosmos.bajajfinservsecurities.in";
export const Samadhan_Base_Url =
  "https://samadhanapi.bajajfinservsecurities.in/api";
export const Msil_Base_Url =
  "https://uat-ws.bajajfinservsecurities.in/msil-bfsl-services";
export const hniBaseUrl = "https://cosmos.bajajfinservsecurities.in/api/rm/hni";
export const DASHBOARD_DEFAULT = {
  ClientStatus_URL: baseURL + "/Default/ClientStatus", //
  BuisnessSnapshot_URL: baseURL + "/Default/BusinessSnapshotNew", //
  RevenueSnapshot_URL: baseURL + "/Default/RevenueSnapshot", //
  AUMSnapshot_URL: baseURL + "/Default/AUMSnapshot", //
  SaleSnapshot_URL: baseURL + "/Default/SaleSnapshot", //
  ClientSnapshot_URL: baseURL + "/Default/ClientSnapshot", //
  GetBirthdayList_URL: baseURL + "/Default/Birthday", //
  SendBirthdayWishEmail_URL: baseURL + "/Default/BirthdaySendWishEmail", //
  TopActiveClient_URL: baseURL + "/Default/TopActiveClients", //
  TopInActiveClient_URL: baseURL + "/Default/TopInActiveClients", //
  DefaultRanking_URL: baseURL + "/Default/DefaultRanking", //
  NewDefaultRanking_URL: baseURL + "/Default/DefaultRankingNew", //
  SummaryReactivation_URL: baseURL + "/Default/SummaryReactivation", //
  SummaryReactivationDetail_URL: baseURL + "/Default/SummaryReactivationDetail", //
  RevenueSnapshotEquityModel_URL:
    baseURL + "/Default/RevenueSnapshotEquityDetails", //
  RevenueSnapshotFnoModel_URL: baseURL + "/Default/RevenueSnapshotFNODetails", //
  AUMSnapshotEquityModel_URL: baseURL + "/Default/AUMSnapshotDetails", //
  RevenueSnapshotMTFModel_URL: baseURL + "/Default/DefaultMtfDetails", //
};

export const DASHBOARD_EQUITY = {
  //   ClientStatus_URL: baseURL + "/Default/ClientStatus",
  IpoDetails_URL: baseURL + "/Equity/IpoDetails", //
  EquityClientStatusGraph_URL: baseURL + "/Equity/EquityClientStatus", //
  StockSegmentation_URL: baseURL + "/Equity/StockSegmentation", //
  BrokerageSummary_URL: baseURL + "/Equity/BrokerageSummary", //
  TodayClientInfo_URL: baseURL + "/Equity/TodayClientInfo", //
  TopActiveClient_URL: baseURL + "/Equity/TopActiveClients", //
  TopInActiveClient_URL: baseURL + "/Equity/TopInActiveClients", //
  EquityRanking_URL: baseURL + "/Equity/EquityRanking", //
  NewEquityRanking_URL: baseURL + "/Equity/EquityRankingNew", //
  NakedDebit_URL: baseURL + "/Equity/NakedDebit_ClientInfo", //
};
//
export const DASHBOARD_CLIENT_OVERVIEW = {
  BasicDetails_URL: baseURL + "/Default/v2/BasicDetails", //
  PortfolioAnalysis_URL: baseURL + "/Equity/PortfolioAnalysis", //
  NetWorth_URL: baseURL + "/Equity/NetWorth", //
  PortfolioOverYear_URL: baseURL + "/Equity/PortfolioOverYear", //
  GetAllDocuments_URL: baseURL + "/Default/GetAllDocuments", //
  DownloadAllDocuments_URL: baseURL + "/Default/DownloadDocument", //
  IpoInfo_URL: baseURL + "/Default/IpoInfo", //
  ClientSummary_URL: baseURL + "/Equity/ClientSummary", //
  SummaryClient_URL: baseURL + "/Equity/ClientSummaryDetail", //
  ClientBrokerage_URL: baseURL + "/Default/ClientBrokerage", //
};

export const DASHBOARD_CLIENT_DETAIL_EQUITY = {
  InvestmentSnapshot_URL: baseURL + "/Equity/InvestmentSnapshot?clientCode=", //
  TradingTransactions_URL: baseURL + "/Equity/TradingTransactionsPage", //
  // Holdings_URL: baseURL + "/Equity/Holdings", //
  Holdings_URL: baseURL + "/Report/holding",
  Position_URL: baseURL + "/Report/Positions",
  Stock_Analytics_URL: baseURL + "/Client/StockAnalytics", //
  Stock_Analytics_New_URL: baseURL + "/Default/StockAnalyticsNew", //
  DividendInfo_URL: baseURL + "/default/Dividend", //
  MarginDetail_URL: baseURL + "/default/MarginDetails", //
  PayinPayout_URL: baseURL + "/default/PayinPayoutDetails", //
  PortfolioGrowth_URL: baseURL + "/Default/PortfolioGrowth", //
  PortfolioOverview_URL: baseURL + "/Equity/PortfolioOverview", //
  PayinDetails_URL: baseURL + "/Default/PayInDetails", //
  PayoutDetails_URL: baseURL + "/Default/PayOutDetails", //
};

export const Dashboard_Client_Report = {
  CombineLedgerReport_URL: baseURL + "/Report/CombineLedgerReport", //
  RevenueClientReport_URL: baseURL + "/Report/RevenueClientReport", //
  DividendReport_URL: baseURL + "/Report/DividendReportTrade", //
  DPReport_URL: baseURL + "/Report/DPReportTrade", //
  ClientHoldingReport_URL: baseURL + "/Report/ClientHoldingReport", //
  LedgerReport_URL: baseURL + "/Report/LedgerReport", //
  MorningLimitReport_URL: baseURL + "/Report/MorningLimitReport", //
  MTFDelayPaymentReport_URL: baseURL + "/Report/MTFDelayPaymentReport", //
  MTFDetail_URL: baseURL + "/Report/MTFDetails", //
  PnlReport_URL: baseURL + "/Report/PnlReport", //
  TaxReport_URL: baseURL + "/Report/TaxReportTrade", //
  FundTransactionTrade_URL: baseURL + "/Report/FundTransactionTrade", //
  CostReportTrade_URL: baseURL + "/Report/CostReportTrade", //
  Last10TransactionTrade_URL: baseURL + "/Report/Last10TransactionTrade", //
  TradeSummary_URL: baseURL + "/Report/TradeSummaryTrade", //
  LtcgReport_URL: baseURL + "/Report/LtcgReportTrade", //
  LeviesReport_URL: baseURL + "/Report/LeviesReport", //
  GetContractList_URL: baseURL + "/Report/GetContractList", //
  AumClientReport_URL: baseURL + "/Report/AumClientReport", //
  Hierarchy_URL: baseURL + "/Report/HierarchyReport", //
  Single_Holding_URL: baseURL + "/Report/GetScriptName", //
  Script_Wise_Holidng: baseURL + "/Report/V2/ScriptWiseHolidng ", //
  Loan_No_URL: baseURL + "/Report/GetLoanNo", //
  GetSoaDetailURL: baseURL + "/Report/GetSOADetail", //
  GetIVRDetailURL: baseURL + "/Report/GetIVRDetail", //
  // Script_Wise_Holidng: baseURL + "/Report/ScriptWiseHolidng",
  Aging_Report_URL: baseURL + "/Report/AgingReport", //
  TentativeMargin_URL: baseURL + "/Report/GetTentativeMargin", //
  Margin_Report_URL: baseURL + "/Report/GetMarginShortage", //
  IncomeRangeProof_Report_URL: baseURL + "/Report/IncomeRangeProof", //
  IncomeDeclaration_Report_URL: baseURL + "/Report/IncomeDeclaration", //
  IntrestReportTrade_Report_URL: baseURL + "/Report/IntrestReportTrade", //
  Revenue_Report_URL: baseURL + "/Report/ReveneuReportRmtoCos", //
  YieldReport_URL: baseURL + "/Report/YieldReport", //
  PledgeMasterReport_URL: baseURL + "/Report/PledgeHoldingReport", //
  ConsolidatedReport_URL: baseURL + "/Report/ConsolidatedReport",
  Get_VoucherType: baseURL + "/Report/GetLedgerVoucherType",
  Get_ExchangeType: baseURL + "/Report/GetExchangeType",
  Get_ReportType: baseURL + "/Report/GetRportType",
  MtfPos_Report: baseURL+"/Report/MTFPositionReport"
 

};

export const Client_Search = {
  // Search_URL: baseURL + "/Default/ClientSearch",
  Search_URL: baseURL + "/Default/ClientSearchPagination", //
};

export const Login_Page = {
  Login_URL: baseURL + "/Default/LoginNew", //
  Forget_UserName_URL: baseURL + "/Default/ForgotUsername", //
  Forgot_Password: baseURL + "/Default/ForgotPassword", //
  Forgot_PasswordV3: baseURL + "/Default/V3/ForgetPassword", //
  Forgot_ChangePasswordV2: baseURL + "/Default/V2/ChangePassword", //
  Change_Password: baseURL + "/Default/ResetPassword", //
};

export const Header = {
  Logout_URL: baseURL + "/Default/Logout", //
};

export const Onboarding_Page = {
  OnbOarding_URL_NEW: baseURL + "/Default/V2/OnBoardingWithStatusType", //
  OnboardingFilter_URL: baseURL + "/Default/FilterSearch", //
  OnboardingSaveFilterSearch_URL: baseURL + "/Default/SaveFilterSearch", //
  OnboardingGetFilterSearch_URL: baseURL + "/Default/GetFilterSearch", //
  OnboardingResetFilter_URL: baseURL + "/Default/ResetFilterSearch", //
};

export const Help_Guide = {
  Client_Support_URL: baseURL + "/Default/ClientSupport", //
};

export const Get_Details = {
  Get_Ticket_Details_URL:
    Samadhan_Base_Url + "/GetClientDetails/GetClientTickets", //
  Get_Ticket_Coversation:
    Samadhan_Base_Url + "/GetClientDetails/GetTicketConversation", //
};
export const LoginInfo_Active_Inactive = {
  Get_Login_Info_URL: Msil_Base_Url + "/user/LoginUserInfo/1.0.0", //
};
export const Contact_Us = {
  Contact_Us_URL: baseURL + "/Default/ContactUsDetails", //
};

export const Rm_Ap_Mapping = {
  //Ap RM

  Get_AP_Code_URL: baseURL + "/Report/GetAPCode", //
  Get_Branch_Name_URL: baseURL + "/Report/GetBranch", //
  Get_Branch_Name_URL: baseURL + "/Report/GetBranch", //
  Save_Rm_Code_Ap_Name_URL: `${baseURL}/Report/SaveRmCodeApName`, //
  RM_AP_Mapping_Report_URL: `${baseURL}/Report/RMAPMappingReport`, //
  Update_RM_URL: `${baseURL}/Report/UpdateRM`, //
  //client RM
  Get_Client_Code_URL: `${baseURL}/Report/GetClientCode`, //
  RM_Client_Mapping_Report_URL: `${baseURL}/Report/RMClientMappingReport`, //
  Get_RM_Name_URL: `${baseURL}/Report/GetRMName`, //
  Update_Client_RM_URL: `${baseURL}/Report/UpdateClientRM`, //
  Save_Client_Rm_Code_Name_URL: `${baseURL}/Report/SaveClientRmCodeName`, //
};
export const AP_Master = {
  Get_Ap_Codes_URL: baseURL + "/AutoPayout/GetAPCodes", //
  Get_ClientAp_Code_URL: baseURL + "/AutoPayout/GetClientAPCodes", //
  Get_Ap_Master_URL: baseURL + "/AutoPayout/displaybrokerage", //
  GetClientMaster_URL: baseURL + "/AutoPayout/GetClientMaster", //
  BrokerageWiseModules_URL: baseURL + "/AutoPayout/BrokerageWiseModules", //
  Submit_ApMaster_URL: baseURL + "/AutoPayout/UpdateBrokerage", //
  Submit_ClientMaster_URL: baseURL + "/AutoPayout/UpdateBrokerageToClient", //
  Get_Master_Codes_URL: baseURL + "/AutoPayout/GetMasterAPCodes", //
  BrokerageWiseModulesForClient_URL:
    baseURL + "/AutoPayout/BrokerageWiseModulesForClient", //
  GetClientCodes_URL: baseURL + "/AutoPayout/GetClientCodes",
  UploadOnAwsFile_URL: baseURL + "/AutoPayout/uploadfileonaws", //
  UpdateRemark_URL: baseURL + "/AutoPayout/UpdateRemarks",
  BankNames_URL: baseURL + "/AutoPayout/banknames",
  BranchLocation_URL: baseURL + "/AutoPayout/branchloc",
  GetIfsc_URL: baseURL + "/AutoPayout/ifsc",
  ImpsBankVerify_URL: baseURL + "/AutoPayout/impsbankverification",
  GetBankNameByIfsc_URL: baseURL + "/AutoPayout/banknamebyifsc",
  GetBrokerageSlab_URL:baseURL+"/AutoPayout/getbrokerageslabformodule4",
  GetApSharing_URL:baseURL+"/AutoPayout/getapsharingformodule4"
};

export const AP_Payout_Rms = {
  GetMasterAPList_URL: baseURL + "/AutoPayout/getpayoutforfranchiseeteam", //
  GetClientRawData_URL: baseURL + "/AutoPayout/GetClientsRawData", //
  InsertPayoutDetails_URL: baseURL + "/AutoPayout/updatepayoutbyfranchiseeteam", //
  RmsDataList_URL: baseURL + "/AutoPayout/getpayoutforrmsteam", //
  RmsInsertUpdate_URL: baseURL + "/AutoPayout/updatepayoutbyrmsteam", //
};

export const Account_Rights = {
  GetAccountRightsData_URL: baseURL + "/AutoPayout/getpayoutforfinanceteam", //
  InsertAccountRightsData_URL: baseURL + "/AutoPayout/updatepayoutbyfinanceteam", //
};

export const AP_Payout_Banking = {
  GetBankingDetails_URL: baseURL + "/AutoPayout/getpayoutforbankingteam", //
  InsertBankingDetails_URL: baseURL + "/AutoPayout/updatepayoutbybankingteam", //
};

export const IPO_Master = {
  GetMasterIpoData_URL: baseURL + "/AutoPayout/MasterDataDownload", //
  UploadIpoMaster_URL: baseURL + "/AutoPayout/UploadIpoMasterData", //
};

export const Freeze_Unfreeze = {
  sendOtp_URL: baseURL + "/FreezeUnfreeze/SendOTP",
  validateOtp_URL: baseURL + "/FreezeUnfreeze/ValidateOTP",
  SkipAuthentication: baseURL + "/FreezeUnfreeze/SkipAuthentication",
  SkipAuthenticationProceed:
    baseURL + "/FreezeUnfreeze/SkipAuthenticationProceed",
  UpdateFreezUnfreezStatus:
    baseURL + "/FreezeUnfreeze/UpdateFreezUnfreezStatus",
};


export const Hni_Admin_Api = {
  gethnipackdetails: hniBaseUrl + "/gethnipackdetails",
  inserthnipackdetail: hniBaseUrl + "/inserthnipackdetail",
  listofhnipackdetail: hniBaseUrl + "/listofhnipackdetail",
  deactivatehnipackdetail: hniBaseUrl + "/deactivatehnipackdetail",
  generatesocialmedialink: hniBaseUrl + "/generatesocialmedialink",
  getPersonalisedDetail: hniBaseUrl + "/personaliseddetail",
  insertPersonalDetail: hniBaseUrl + "/insertpersonaliseddetail",
  getDpcList: hniBaseUrl + "/dpc",
  getMtfList: hniBaseUrl + "/mtf",
  uploadDocOnAwsFile: hniBaseUrl + "/uploadfileonaws",
  updateDetails: hniBaseUrl + "/updatepersonaliseddetail",
  updateRemarks: hniBaseUrl + "/updateremarksforpersonaliseddetail",
  generateLink: hniBaseUrl + "/personalisedlink",
  getGeneralDetail: hniBaseUrl + "/generaldetail",
  insertGeneralDetail: hniBaseUrl + "/insertgeneraldetail",
  getPackDetails: hniBaseUrl + "/getgeneralhnipackdetails",
  updateGeneralDetails: hniBaseUrl + "/updategeneraldetail",
  generateGeneralLink: hniBaseUrl + "/generallink",
  updateGeneralRemarks: hniBaseUrl + "/updateremarksforgeneraldetail"
}

export const CLIENT_FNO={
   Get_Client_FnO: baseURL+ "/fnoloss/clientsfnoloss",
   Update_Document:baseURL+"/fnoloss/uploadledgerdoc",
   Download_Doc:baseURL+"/fnoloss/downlodledgerdoc"
}
export const Hierarchy={
  Insert_Business_Data:baseURL+"/Hierarchy/businessheaddetails",
  Get_Business_Data:baseURL+"/Hierarchy/getbusinessheaddetails",
  Get_NationalHead_Data: baseURL+"/Hierarchy/getnationalheaddetails",
  Insert_NationalHead_Data: baseURL+"/Hierarchy/nationalheaddetails",
  Search_Business_Head:baseURL+"/Hierarchy/businessheaddropdown",
  Get_Zonal_Data:baseURL+"/Hierarchy/getzonalmaster",
  Insert_Zonal_Data:baseURL+"/Hierarchy/zonalmaster",
  Search_National_Head:baseURL+"/Hierarchy/nationalheaddropdown",
  Get_Regional_Data: baseURL+"/Hierarchy/getregionmaster",
  Insert_Regional_Data:baseURL+"/Hierarchy/regionmaster",
  Search_Zonal_Head:baseURL+"/Hierarchy/zonalcodedropdown",
  Get_Branch_Data: baseURL+"/Hierarchy/getbranchmaster",
  Insert_Branch_Data:baseURL+"/Hierarchy/branchmaster",
  Search_Region_Head:baseURL+"/Hierarchy/regioncodedropdown",
}